import PaymentTypeEdit from './PaymentTypeEdit';
import PaymentTypesList from './PaymentTypesList';

const resource = {
  list: PaymentTypesList,
  edit: PaymentTypeEdit,
};

export default resource;
